import React from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/client';
import client from '../lib/apolloClient';
import PartnerOnboardingWizard from '../components/Succeedo/PartnerOnboarding/PartnerOnboardingWizard';

// ReactOnRails props are forwarded explicitly (not spread) to satisfy the
// project's no-spread lint rule. `mode` switches between the full self-signup
// wizard and the lightweight deal-team-invite-accept variant.
const SucceedoPartnerOnboardingContainer = ({ mode, returnTo, prefilled }) => (
  <ApolloProvider client={client}>
    <PartnerOnboardingWizard
      mode={mode}
      returnTo={returnTo}
      prefilled={prefilled}
    />
  </ApolloProvider>
);

SucceedoPartnerOnboardingContainer.propTypes = {
  mode: PropTypes.oneOf(['invite_accept', 'self_signup']),
  returnTo: PropTypes.string,
  prefilled: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    orgName: PropTypes.string,
    partnerCategory: PropTypes.string,
  }),
};

SucceedoPartnerOnboardingContainer.defaultProps = {
  mode: 'self_signup',
  returnTo: null,
  prefilled: {},
};

export default SucceedoPartnerOnboardingContainer;
